var PAGE_INSTANCE_ID_PROVIDER_ITEM_KEY = 'CURRENT_PAGE_INSTANCE_ID';
var UBIPageInstanceIdProvider = (function () {
    function UBIPageInstanceIdProvider(options) {
        this.storageManager = options.storageManager;
    }
    UBIPageInstanceIdProvider.prototype.getPageInstanceId = function () {
        return this.storageManager.getItem(PAGE_INSTANCE_ID_PROVIDER_ITEM_KEY);
    };
    UBIPageInstanceIdProvider.prototype.setPageInstanceId = function (pageInstanceId) {
        this.storageManager.setItem(PAGE_INSTANCE_ID_PROVIDER_ITEM_KEY, pageInstanceId);
    };
    return UBIPageInstanceIdProvider;
}());
export { UBIPageInstanceIdProvider };
//# sourceMappingURL=PageInstanceIdProvider.js.map